import React from 'react';
import styled from 'styled-components';
import { FormattedCurrency, FormattedMessage } from 'i18n';
import { mediaQueries } from 'styles/utils/mediaQueries';
import flexbox from 'styles/utils/flexbox';
import PrimaryButton from 'components/buttons/primaryButton/PrimaryButton';

function PriceComponent({ price }) {
  return (
    <Root>
      <PriceWrapper>
        <PriceFrom>
          <FormattedMessage id={'pricesFrom.label'} description={'Price from'} defaultMessage={'Price from'} />
        </PriceFrom>
        <PriceContent>
          <FormattedCurrency value={price} />
        </PriceContent>
      </PriceWrapper>
      <Separator>
        <hr />
      </Separator>
      <ButtonWrapper>
        <Button>
          <FormattedMessage id={'viewDetails.label'} description={'View details'} defaultMessage={'View details'} />
        </Button>
      </ButtonWrapper>
    </Root>
  );
}

export default PriceComponent;

const Root = styled.div`
  flex: 1 0 auto;
  background: ${({ theme }) => `${theme.colors.primary.light}`};
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-left: ${({ theme }) => `solid 1px ${theme.colors.primary.default}`};

  ${mediaQueries.fromAndBelow.tablet`
		max-width: 100%;
		height: 45%;
		border-left: none;
		border-top: ${({ theme }) => `solid 1px ${theme.colors.primary.default}`};
  `}
`;

const PriceWrapper = styled.div`
  ${flexbox({
    flexDirection: 'column',
    justifyContent: 'center',
  })}
  flex: 1 0 45%;

  ${mediaQueries.fromAndAbove.desktop`
    flex: 1 0 35%;
  `}
`;

const PriceFrom = styled.div`
  font-size: 1.2em;
  text-transform: uppercase;
  font-family: ${({ theme }) => theme.fonts.sansSerif};
  margin-bottom: 8px;
  margin-top: 8px;
  color: ${({ theme }) => `${theme.colors.text.light}`};
`;

const PriceContent = styled.div`
  color: ${({ theme }) => `${theme.colors.text.price}`};
  font-weight: 700;
  font-size: 3.6em;
  font-family: ${({ theme }) => theme.fonts.sansSerif};

  ${mediaQueries.fromAndBelow.tablet`
		font-size: 2.6em;
	`}
`;

const Separator = styled.div`
  display: none;

  ${mediaQueries.fromAndAbove.desktop`
    display: block;
    flex: 1 0 1px;
    width: 45%;
    height: 1px;
    margin: 0 auto;
  `}

  hr {
    border: ${({ theme }) => `0.5px solid ${theme.colors.primary.default}`};
  }
`;

const ButtonWrapper = styled.div`
  padding: 18px;
`;

const Button = styled(PrimaryButton)`
  width: 100%;
  font-size: 2em;
  font-weight: 700;
  font-size: 1.2em;

  ${mediaQueries.fromAndAbove.desktop`
    padding: 8px;
    font-size: 1.8em;
    height: 41px;
    width: 150px
    margin: 0 auto;
  `}
`;
